import React from 'react'
import styles from './Baa.css'
import KpBaa from './KpBaa'

const Baa = props => (
  <div data-page="baa" className={styles.Baa}>
    <div className={styles.BaaContent}>
      <KpBaa />
    </div>
  </div>
)

export default Baa



// WEBPACK FOOTER //
// ./src/legacy/pages/Baa/Baa.jsx